import axios from "axios";

import { GqlCollectionInformationResponse } from "./types";

import { env } from "~/env";

export const getCollectionInformation = async (collectionId: string) => {
  const { data } = await axios.request<GqlCollectionInformationResponse>({
    method: "post",
    baseURL: env(
      "SHOPIFY_SHOP_EQUIPMENTSHARE_COM_SHOPIFY_FEATURED_PRODUCTS_BASE_URL"
    ),
    url: "/api/2023-07/graphql.json",
    headers: {
      "X-Shopify-Storefront-Access-Token": env(
        "SHOPIFY_SHOP_EQUIPMENTSHARE_COM_SHOPIFY_FEATURED_PRODUCTS_PUBLIC_TOKEN"
      )!,
      "Content-Type": "application/json",
    },
    data: {
      operationName: "GetCollectionForFrontEnd",
      query: `#graphql
                query GetCollectionForFrontEnd($collectionId: ID!) {
                    collection(id: $collectionId) {
                        id
                        description
                        handle
                        title
                        image {
                            url
                            altText
                        }
                        products(first: 250) {
                            nodes {
                                handle
                                featuredImage {
                                    url
                                    altText
                                }
                                title
                                id
                            }
                        }
                    }
                }
            `,
      variables: {
        collectionId,
      },
    },
  });

  const errors = [...(data.errors || []), ...(data.data.userErrors || [])];

  if (errors.length) {
    throw errors.map((err: { message: string }) => err.message).join(" | ");
  }

  const { id, handle, description, image, title } = data.data.collection;

  return {
    products: data.data.collection.products.nodes.map((node) => node),
    information: {
      id,
      handle,
      description,
      image,
      title,
    },
  };
};
